// extracted by mini-css-extract-plugin
module.exports = {"artContent":"blog_artContent__1cZ3E","artFooter":"blog_artFooter__2pyAB"};